/** 警告を表示する残りMPの閾値 */
const WARNING_THRESHOLD = 1;

/**
 * MP表示UI - 現在のMP使用量と最大MPを表示
 */
export class MPDisplay {
  private container: HTMLElement;
  private currentCost: number = 0;
  private maxMP: number = 0;

  constructor(parentElement: HTMLElement) {
    this.container = document.createElement("div");
    this.container.className = "mp-display";
    this.container.setAttribute("aria-label", "MP表示");
    this.container.setAttribute("role", "status");
    this.container.setAttribute("aria-live", "polite");
    parentElement.appendChild(this.container);

    this.render();
  }

  /**
   * MP情報を更新
   */
  update(currentCost: number, maxMP: number): void {
    this.currentCost = currentCost;
    this.maxMP = maxMP;
    this.render();
  }

  /**
   * UIを再描画
   */
  private render(): void {
    const isOverLimit = this.currentCost > this.maxMP;
    const remaining = this.maxMP - this.currentCost;

    this.container.replaceChildren();
    this.container.classList.toggle("mp-display--over", isOverLimit);
    this.container.classList.toggle(
      "mp-display--warning",
      remaining <= WARNING_THRESHOLD && !isOverLimit
    );

    const label = document.createElement("span");
    label.className = "mp-display__label";
    label.textContent = "MP";
    this.container.appendChild(label);

    const value = document.createElement("span");
    value.className = "mp-display__value";
    value.textContent = `${this.currentCost} / ${this.maxMP}`;
    this.container.appendChild(value);

    if (isOverLimit) {
      const warning = document.createElement("span");
      warning.className = "mp-display__warning";
      warning.textContent = "超過!";
      this.container.appendChild(warning);
    }
  }

  /**
   * 現在のコストを取得
   */
  getCurrentCost(): number {
    return this.currentCost;
  }

  /**
   * 最大MPを取得
   */
  getMaxMP(): number {
    return this.maxMP;
  }
}
